export const styles = {
  banerPaper: {
    padding: "16px",
    width: "360px",
    borderRadius: "8px",
    position: "relative",
    overflow: "hidden",
    background: "linear-gradient(30deg, white 50%, #DBE6FF 100%)",
  },
  banerImage: {
    position: "absolute",
    top: "50%",
    right: "0",
    zIndex: 0,
    transform: "translateY(-50%)",
  },
  banerContent: {
    position: "relative",
    zIndex: 1,
    marginRight: "70px",
  },
};
